<template>
    <v-dialog v-model="show" persistent max-width="80%">
        <Card>
            <v-card-text style="max-height: 80vh; overflow-y: auto">
                <v-row v-if="!isViewMode">
                    <v-col cols="12" md="10">
                        <span class="titulo-retencion">Solicitud</span>
                        <span class="titulo-header">Crear Solicitud de Retención</span>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" md="10">
                        <span class="titulo-retencion">Retención # {{ solicitudLocal.id }}</span>
                        <span class="titulo-header"> {{ solicitudLocal.titulo }}</span>
                    </v-col>
                </v-row>

                <div>
                    <div ref="retencionSection">
                        <RetencionForm v-if="show" :key="mode + '-' + (solicitudLocal.id || 'new')" :mode="redMode"
                            :solicitud="solicitudLocal" :showActions="showActions" :isCreatingNew="true"
                            @retencion="saveRetencionStep($event)"
                        />
                    </div>

                    <div ref="clienteSection">
                        <ClienteForm :key="mode + (solicitudLocal.id || Math.random())" :mode="clientMode"
                            :solicitud="solicitudLocal" @onSubmit="saveClient" @onCancel="stepBack"
                            :clientSave="clientSave" />
                    </div>

                    <div v-if="isViewMode">
                        <SeguimientoForm :solicitud="solicitudLocal" />
                    </div>
                </div>
                <v-row class="mt-6" justify="end">
                    <v-col cols="auto" class="text-right">
                        <v-btn rounded dark color="#b11f1f" @click="cancelar" :disabled="loading">
                            Cerrar
                        </v-btn>
                        <v-btn rounded dark color="#b11f1f" class="ml-2" @click="saveRetencion" :loading="loading"
                            :disabled="loading" v-if="!isInsertingClient && !isViewMode && !insertedRetencion">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>
                <CommonConfirmationModal :dialog="showConfirmacion" @userChoice="onConfirmacion" />
            </v-card-text>
        </Card>
    </v-dialog>
</template>

<script>
import RetencionForm from "@/components/solicitudes/forms/RetencionForm.vue";
import CommonConfirmationModal from "@/components/commondComponents/CommonConfirmationModal.vue";
import ClienteForm from "@/components/solicitudes/forms/ClienteForm.vue";
import Card from "@/components/commondComponents/Card.vue";
import SeguimientoForm from "@/components/solicitudes/forms/SeguimientoForm.vue";
import { createSolicitudRetencion } from "@/services/solicitudService";
export default {
    components: { RetencionForm, ClienteForm, SeguimientoForm, Card, CommonConfirmationModal },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: "create",
        },
        showActions: {
            type: Boolean,
            default: false,
        },
        solicitud: {
            type: Object,
            default: () => ({}),
        },
        emisionId: {
            type: [String, Number],
            default: null,
        },
        ignoreClientStep: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            solicitudLocal: {},
            rol: JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || "",
            loading: false,
            redMode: "",
            clientMode: "view",
            clientSave: false,
            showConfirmacion: false,
        };
    },
    watch: {
        solicitud: {
            immediate: true,
            deep: true,
            handler(newVal) {
                this.solicitudLocal = JSON.parse(JSON.stringify(newVal || {}));
            },
        },
        mode: {
            immediate: true,
            handler(newMode) {
                this.redMode = newMode;
            },
        },
    },
    computed: {
        isViewMode() {
            return this.mode === "view";
        },
        isInsertingClient() {
            return this.clientMode === "create";
        },
        insertedRetencion() {
            return this.redMode === "create";
        },
    },
    methods: {
        saveRetencionStep(solicitudLocal) {
            this.redMode = "view";
            if (this.ignoreClientStep === false) {
                this.clientSave = true;

            }

            this.solicitudLocal = solicitudLocal;
            const section = this.$refs.clienteSection;
            if (section) section.scrollIntoView({ behavior: "smooth" });
        },

        saveClient(cliente) {
            this.solicitudLocal = {
                ...this.solicitudLocal,
                ...cliente,
            };
            this.clientSave = false;
            this.clientMode = "view";
            this.saveRetencion();
        },
        saveRetencion() {
            this.showConfirmacion = true;
        },
        onConfirmacion(confirmado) {
            this.showConfirmacion = false;
            if (confirmado) this.enviarRetencion();
        },
        async enviarRetencion() {
            this.loading = true;
            const data = {
                ...this.solicitudLocal,
                origen: "Portal",
                status: 1,
                telefono: this.solicitudLocal.celular,
                emisionId: this.emisionId,
            };

            try {
                const res = await createSolicitudRetencion(data);
                if (res.status === 200) {
                    this.$toast.success(res.message || "Solicitud de retención creada");
                    setTimeout(() => {
                        this.$router.push(`/solicitud/${res.data.solicitudId}`);
                    }, 1500);
                } else {
                    const msg = typeof res === "string" ? res : (res?.message || "No se pudo crear la retención");
                    this.$toast.info(msg);
                }
            } catch (error) {
                console.error(error);
                this.$toast.error("Ocurrió un error al crear la retención");
            } finally {
                this.loading = false;
            }
        },
        stepBack() {
            this.redMode = "create";
            this.solicitudLocal.cliente_id = null;
            this.$nextTick(() => {
                const section = this.$refs.retencionSection;
                if (section) section.scrollIntoView({ behavior: "smooth" });
            });
        },

        cancelar() {
            this.solicitudLocal = {};
            this.redMode = "create";
            this.clientMode = "view";
            this.clientSave = false;

            this.$emit("close");
            this.$emit("reset");
        },
    },
};
</script>

<style scoped>
.titulo-retencion {
    font-weight: 700;
    font-size: 32px;
    color: #130707;
    display: block;
    padding-bottom: 5px;
}

.titulo-header {
    font-weight: 600;
    font-size: 20px;
    display: block;
    margin-top: 4px;
}
</style>
